import { Question } from '@kp/question-set/models/question.model';
import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class Page implements Deserializable<any, Page>, Serializable<JsonObject> {
  constructor(public questions?: Question[]) {}

  deserialize(input: any): Page {
    if (input == null) {
      return null;
    }
    this.questions = input.questions.map((question) => new Question().deserialize(question));
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['questions'] = this.questions.map((question) => question.serialize());
    return json;
  }
}
